import React from "react";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { Link } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";

function Footer() {
  const { CMS } = useSelector((state) => state.auth, shallowEqual);
  return (
    <>
      <footer className="footer_v2">
        <div className="container container_frnt">
          <div className="row d-flex align-items-center">
            <div className="col-xl-3 col-lg-2 col-md-6">
              <img
                alt="Logo"
                className="ftr_logo"
                src={toAbsoluteUrl("/media/logos/logo-light.svg")}
              />
            </div>
            <div className="col-xl-6 col-lg-7 text-right ftr_p_lnks d-flex align-items-center justify-content-center">
              <div className="text-white f-w-400 fn_s_14  d-inline-flex align-items-center">
                <span className="fn_s_18 copysymble">&copy;</span> QRFID GOLD
                2022. All Rights Reserved.
              </div>
              <Link to="#">Privacy Policy</Link>
              <Link to="#">Terms and Conditions</Link>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-6 text-right ftrscl_icns">
              {CMS.FOOTERLINKS && CMS.FOOTERLINKS.footerLinks
                ? CMS.FOOTERLINKS.footerLinks.map((footer, idx) => {
                    if (footer.status === "ACTIVE")
                      return (
                        <a key={idx} href={"//" + footer.link} target="_blank">
                          <i
                            className={`fab fa-${
                              footer.name === "Facebook"
                                ? "facebook-f"
                                : footer.name === "Telegram"
                                ? "telegram-plane"
                                : footer.name === "LinkedIn"
                                ? "linkedin-in"
                                : footer.name.toLowerCase()
                            }`}
                          ></i>
                        </a>
                      );
                    return null;
                  })
                : null}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
